(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('phishingDashboardMicrosoftScl', ["path", "timeResolutions", "defaultChartColorList", "http", "sqlQueries", function (path, timeResolutions, defaultChartColorList, http, sqlQueries) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('phishing-dashboard/microsoft-scl').template('microsoft-scl'),
            scope: { resolution: '=' },
            link: function ($scope, element) {
                function initializeModel() {
                    if ($scope.model) {
                        return;
                    }
                    $scope.model = {
                        flotOptions: {
                            series: {
                                pie: {
                                    show: true,
                                    highlight: { opacity: 0.2 },
                                    innerRadius: 45,
                                    radius: 60,
                                    stroke: { width: 0 }
                                }
                            },
                            colors: defaultChartColorList,
                            grid: {
                                hoverable: true,
                                clickable: true
                            },
                            legend: {
                                labelFormatter: function (label, series) {
                                    return label;
                                },
                                container: element.find('.chart-legend')
                            },
                            tooltip: true,
                            tooltipOpts: {
                                defaultTheme: false,
                                content: '%s',
                                shifts: {
                                    x: 0,
                                    y: 20
                                },
                                cssClass: 'pieChartTip',
                                disableCentering: true
                            }
                        },
                        watchFlotOptions: false
                    };
                    $scope.initialized = true;
                }
                $scope.widgetApi = {};
                $scope.loadData = function () {
                    var resolution = timeResolutions.get($scope.resolution);
                    return http.get(sqlQueries('ap_avanan_o365_scl')).params({ resolution: resolution.stepMax + ' ' + resolution.step + 's' }).then(function (response) {
                        initializeModel();
                        $scope.model.data = _(response.data.rows).map(function (row) {
                            return {
                                label: '<a class="legend-line">' + '<div class="legend-label">' + row.SCL + '</div>' + '<div class="legend-count">' + row.count + '</div>' + '</a>',
                                data: row.count
                            };
                        });
                    });
                };
                $scope.$watchGroup(['resolution'], function () {
                    $scope.widgetApi.reload();
                });
            }
        };
    }]);
}());